import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { CONTACT } from '../data/navigation';
export function TopStatement() {
  return <div className="w-full bg-navy text-aluminum" data-id="element-493" data-mp="1bsvg7526aeg7">
      <div className="mx-auto flex max-w-shell flex-col gap-1 px-5 py-2.5 sm:flex-row sm:items-center sm:justify-between sm:gap-6 lg:px-10" data-id="element-494" data-mp="171dg0j7z4hwa">
        <p className="text-[12px] leading-snug sm:text-[13px]" data-id="element-495" data-mp="12z8njnt9hrb8">
          Shear Geometry high-rake CNC lathe tooling for aluminum, copper &amp;
          titanium
        </p>
        <a href={CONTACT.phoneHref} data-analytics="phone-click" data-analytics-location="top-statement" className="inline-flex items-center gap-2 self-start text-[12px] font-medium text-white transition-colors duration-150 ease-precise hover:text-cta sm:self-auto sm:text-[13px]" data-id="element-496" data-mp="t1kqgr86o7pw">
          <PhoneIcon aria-hidden="true" className="h-3.5 w-3.5 text-copper" data-id="element-497" data-mp="2ig8ti1uvwdb9" />
          <span className="hidden sm:inline" data-id="element-498" data-mp="2eg8fujfm0659">
            Application help: {CONTACT.phoneLabel}
          </span>
          <span className="sm:hidden" data-id="element-499" data-mp="3decqxmkuwzuo">Call {CONTACT.phoneLabel}</span>
        </a>
      </div>
    </div>;
}